<template>
  <CommonPage
    ref="publicPage"
    page="ranking"
    @clickRules="gotoRules"
    class="ranking-home"
    :type="type"
    @loginCb="loginCb"
    :activityInfos="activityInfos"
    :havePointsUserCount="havePointsUserCount"
    :allRankingList="allRankingList"
    @topup="topup"
    :joinRankingAllUsers="joinRankingAllUsers"
    :userPoints="userPoints"
  >
    <template #body>
      <section
        :class="[
          'ranking-list-wrapper',
          rankingDatas_top3.length < 3 && rankingDatas.length === 0
            ? 'no-ranking'
            : '',
          type,
        ]"
      >
        <EmptyTips
          v-if="rankingDatas_top3.length < 3 && rankingDatas.length === 0"
        />
        <section class="ranking-list-body" v-else>
          <div class="top-three-wrapper">
            <RankListTop3
              :datas="rankingDatas_top3"
              @likeHandle="likeHandle"
              :todayMaxCancelNum="todayMaxCancelNum"
              :todayMaxNumByLike="todayMaxNumByLike"
              :myselfMaxNumByLike="myselfMaxNumByLike"
              :myselfInRankingInfo="myselfInRankingInfo"
            />
            <div class="placeholder"></div>
          </div>
          <ul
            :class="[
              'ranking-list-other',
              myselfIsInRanking ? 'hasOwner' : '',
              rankingDatas.length === 0 ? 'no-ranking' : '',
            ]"
          >
            <li class="title">{{ $t('ranking.points_reminder') }}</li>
            <li
              :class="['ranking-list']"
              v-for="(item, index) in rankingDatas"
              :key="item.no"
            >
              <RankList
                :list="item"
                type="horizontal"
                :index="index"
                @likeHandle="likeHandle"
                :isOwner="item.isOwner"
                @topup="topup"
                :todayMaxCancelNum="todayMaxCancelNum"
                :todayMaxNumByLike="todayMaxNumByLike"
                :myselfMaxNumByLike="myselfMaxNumByLike"
                :myselfInRankingInfo="myselfInRankingInfo"
              />
            </li>
            <li
              class="ranking-list myself fixed-bottom"
              v-if="myselfIsInRanking && myselfInRankingInfo"
            >
              <RankList
                :list="myselfInRankingInfo"
                type="horizontal"
                :isOwner="true"
                @topup="topup"
                :todayMaxCancelNum="todayMaxCancelNum"
                :todayMaxNumByLike="todayMaxNumByLike"
                :myselfMaxNumByLike="myselfMaxNumByLike"
                :myselfInRankingInfo="myselfInRankingInfo"
              />
            </li>
          </ul>
        </section>
      </section>
      <RankingRulesPopup
        ref="rulesPopup"
        @rulePopupIsClose="rulePopupIsClose"
      />
    </template>
  </CommonPage>
</template>
<script>
  import CommonPage from '../components/CommonPage'
  import RankList from '../components/RankList'
  import RankListTop3 from '../components/RankList/RankListTop3'
  import EmptyTips from '../components/Empty'
  import { mapState } from 'vuex'
  import {
    queryInfo,
    queryRankingList,
    querySomeoneLikes,
    likeSwitch,
  } from '@/api/ranking'
  import {
    getAcitivityInfo,
    getCouponInfos,
    formatCoupon,
    uvidIsOdd,
    covertNumber,
  } from '../helper'
  import RankingRulesPopup from '../Rules/popup'
  import { Toast } from 'vant'

  export default {
    components: {
      CommonPage,
      RankList,
      RankListTop3,
      EmptyTips,
      RankingRulesPopup,
    },
    props: {
      type: {
        default: 'page',
        type: String,
      },
    },
    data() {
      return {
        rankingDatas_top3: [],
        rankingDatas: [],
        activityInfos: {},
        todayMaxCancelNum: 0,
        todayMaxNumByLike: 0,
        dailyLikeCount: 0,
        havePointsUserCount: 0,
        myselfMaxNumByLike: 0,
        rankingRelationCouponInfos: new Map(),
        joinRankingAllUsers: [],
        userPoints: 0,
      }
    },
    computed: {
      ...mapState(['region', 'userInfo']),
      // 所有已上榜的用户
      allRankingList() {
        return [...this.rankingDatas_top3, ...this.rankingDatas]
      },
      loginStatus() {
        const { kicoinId, kicoinToken } = this.userInfo || {}
        if (kicoinId && kicoinToken) {
          return true
        }
        return false
      },
      myselfIsInRanking() {
        const { allRankingList } = this
        const { kicoinId: myKicoinId } = this.userInfo || {}
        return allRankingList.some((item) => item.kicoinId === myKicoinId)
      },
      myselfInRankingInfo() {
        const { allRankingList } = this
        return (allRankingList.filter((item) => item.isMyself) || [])[0] || null
      },
    },
    watch: {
      loginStatus(val) {
        if (val) {
          this.queryRankingListDatas()
        }
      },
    },
    mounted() {
      // 获取活动配置信息
      getAcitivityInfo().then((res = {}) => {
        this.activityInfos = res
        this.activityInitCallback(res)
        if (this.loginStatus) {
          this.getRankingInfos()
        }
      })
      this.setToastStyle()
    },
    methods: {
      activityInitCallback(res) {
        const { extraInfo = {} } = res
        const {
          maxCancelNum,
          maxNum,
          awardRelationList = [],
          maxNumByLike,
        } = extraInfo
        this.todayMaxCancelNum = maxCancelNum
        this.todayMaxNumByLike = maxNum
        this.myselfMaxNumByLike = maxNumByLike
        this.awardRelationList = extraInfo.awardRelationList || []
        const couponIdStings =
          (awardRelationList.map((item) => item.awardContent) || []).join(
            ','
          ) || ''
        // 获取所有的优惠券信息
        if (couponIdStings) {
          getCouponInfos(couponIdStings).then((res = []) => {
            this.couponInfos = res
            if (res && res.length > 0) {
              const coupons = res.map((item) => {
                return formatCoupon(item)
              })
              this.rankingRelationCoupon(awardRelationList, coupons)
            }
            this.queryRankingListDatas()
          })
        } else {
          this.queryRankingListDatas()
        }
      },
      loginCb(res) {
        if (res && res.status === 1) {
          this.getRankingInfos()
        }
      },
      rulePopupIsClose() {
        this.$emit('openRulePopup', false)
      },
      gotoRules() {
        this.$emit('openRulePopup', true)
        this.$refs.rulesPopup && this.$refs.rulesPopup.openPopup()
      },
      // 点赞、取消点赞
      likeHandle(list = {}) {
        const {
          todayMaxCancelNum,
          todayMaxNumByLike,
          myselfMaxNumByLike,
          dailyLikeCount,
          activityInfos,
        } = this
        const { kicoinId = '', liked, dailyBeLikeCount = 0 } = list
        // 如果未登录，则调起登录
        if (!this.loginStatus) {
          const { activityId } = this.activityInfos || {}
          this.$refs.publicPage &&
            this.$refs.publicPage.showLoginPopup({
              act_id: activityId || 'ranking',
            })
          return
        }
        // 如果我自己的被点赞数已经超过了cms中配置的最大的可点赞数，则不能再点赞
        const { extraInfo = {} } = activityInfos
        const { maxNum } = extraInfo
        if (dailyLikeCount > maxNum) {
          this.showToast()
          return
        }
        // 只针对点赞
        // 每日最多可点赞次数，超过则不能点赞
        if (!liked && myselfMaxNumByLike * 1 <= dailyBeLikeCount * 1) {
          this.showToast()
          return
        }
        // 超过每天次数限制操作
        // 取消点赞
        if (liked && todayMaxCancelNum <= 0) {
          this.showToast()
          return
        }
        // 点赞
        if (!liked && todayMaxNumByLike <= 0) {
          this.showToast()
          return
        }
        this.advanceCallAnimation(list)
        const { region, userInfo = {} } = this
        const { kicoinId: myKicoinId } = userInfo || {}

        const { activityId = '' } = activityInfos
        if (!activityId) {
          return
        }
        likeSwitch({
          activityId: activityId,
          country: region,
          likeKicoinId: myKicoinId || '',
          beLikeKicoinId: kicoinId,
          actionType: liked ? 2 : 1,
        }).then(() => {
          this.$nextTick(() => {
            this.queryRankingListDatas(false)
            this.getRankingInfos(liked ? 2 : 1)
          })
        })
      },
      // 1: 点赞， 2： 取消点赞
      getRankingInfos(type) {
        const { kicoinId = '' } = this.userInfo || {}
        const { activityInfos = {} } = this
        const { activityId = '' } = activityInfos
        if (!activityId) {
          return
        }
        queryInfo({
          activityId: activityId,
          country: this.region,
          kicoinId,
        }).then((res = {}) => {
          const {
            dailyLikeCount,
            havePointsUserCount,
            dailyUnlikeCount,
            userPoints,
          } = res
          this.userPoints = userPoints
          this.dailyLikeCount = dailyLikeCount
          this.dailyUnlikeCount = dailyUnlikeCount
          this.havePointsUserCount = havePointsUserCount
          if (type) {
            if (type * 1 === 1) {
              this.todayMaxNumByLike = this.todayMaxNumByLike - 1
            } else {
              this.todayMaxCancelNum = this.todayMaxCancelNum - 1
              this.todayMaxNumByLike = this.todayMaxNumByLike + 1
            }
          } else {
            this.todayMaxCancelNum = this.todayMaxCancelNum - dailyUnlikeCount
            this.todayMaxNumByLike = this.todayMaxNumByLike - dailyLikeCount
          }
        })
      },
      // 查询排行榜单数据
      async queryRankingListDatas(isLoading = true) {
        const myselfLikes = (await this.queryMyselfLikesList()) || []
        const { userInfo = {}, activityInfos = {} } = this
        const { kicoinId = '' } = userInfo || {}
        const { activityId = '' } = activityInfos
        if (!kicoinId || !activityId) {
          return
        }
        queryRankingList(
          {
            activityId: activityId,
            country: this.region,
            kicoinId,
          },
          { isLoading }
        ).then((res) => {
          if (res && res.length) {
            res =
              res.map((item) => {
                // 初始化是否点赞
                item.liked = myselfLikes.includes(item.kicoinId)
                // 将优惠券信息和排行榜中的user绑定
                item.coupon =
                  this.getOneOfRankingRelationCouponInfo(item.rank) || {}
                return item
              }) || []
            this.joinRankingAllUsers = res
            const rankingDatas = this.filterInRankingDatas(res)
            this.rankingDatas_top3 = rankingDatas.slice(0, 3)
            this.rankingDatas = rankingDatas.slice(3)
          }
        })
      },
      // 查询自己给谁点赞了
      queryMyselfLikesList() {
        const { region, userInfo = {}, activityInfos = {} } = this
        const { kicoinId = '' } = userInfo || {}
        const { activityId = '' } = activityInfos
        if (!kicoinId || !activityId) {
          return
        }
        return querySomeoneLikes({
          activityId: activityId,
          country: region,
          kicoinId: kicoinId,
        })
      },
      // 将排名和优惠券关联到一起
      rankingRelationCoupon(awardRelationList = [], couponList = []) {
        const maps = new Map()
        awardRelationList.forEach((item = {}) => {
          const key = [item.minRanking, item.maxRanking]
          const coupon =
            (couponList.filter(
              (list) => list.id.toString() === item.awardContent.toString()
            ) || [])[0] || {}
          maps.set(key, coupon)
        })
        this.rankingRelationCouponInfos = maps
      },
      // 从排名和优惠券的关联信息中获取指定排名的优惠券信息
      getOneOfRankingRelationCouponInfo(rankNo) {
        const { rankingRelationCouponInfos } = this
        let selectedKey = []
        if (rankingRelationCouponInfos) {
          for (let key of rankingRelationCouponInfos.keys()) {
            const [min, max] = key || []
            if (rankNo >= min && rankNo <= max) {
              selectedKey = key
            }
          }
        }
        return rankingRelationCouponInfos.get(selectedKey)
      },
      // 是否上榜
      filterInRankingDatas(datas = []) {
        const { extraInfo } = this.activityInfos || {}
        const { integral = 0 } = extraInfo || {}
        const { kicoinId: myKicoinId } = this.userInfo || {}
        return datas
          .filter((item) => item.points >= integral)
          .map((list, index) => {
            // rank为实际排名，displayRank为显示在榜单上的排名
            list.displayRank = index + 1
            // 标记“我自己”在榜单中
            if (list.kicoinId === myKicoinId) {
              list.isMyself = true
            }
            const i18ntext_thousand = this.$t('ranking.thousand')
            const i18ntext_million = this.$t('ranking.million')
            list.points_format = covertNumber(
              list.points,
              i18ntext_thousand,
              i18ntext_million
            )
            list.belikeCount_format = covertNumber(
              list.belikeCount,
              i18ntext_thousand,
              i18ntext_million
            )
            return list
          })
      },
      topup() {
        const { source = '' } = this.$route.query
        if (source && source === 'share' && uvidIsOdd()) {
          this.$router_push({
            path: `/`,
          })
          return
        }

        if (!this.loginStatus) {
          const { activityId } = this.activityInfos || {}
          this.$refs.publicPage &&
            this.$refs.publicPage.showLoginPopup({
              act_id: activityId || 'ranking',
            })
          return
        }
        if (this.type === 'popup') {
          this.$emit('clickPopup')
          return
        }
        const { game = '' } = this.activityInfos || {}
        if (game.indexOf(',') > -1 || game.toLocaleLowerCase() === 'all') {
          this.$router_push({
            path: `/`,
          })
        } else {
          this.$router_push({
            path: `/${game}`,
          })
        }
      },
      setToastStyle() {
        if (!process.client) {
          return
        }
        const head = document.querySelector('head')
        const style = document.createElement('style')
        style.type = 'text/css'
        style.innerText = `.ranking-toast { word-break: break-word; width: 120px;}`
        head.appendChild(style)
      },
      showToast() {
        Toast.fail({
          message: this.$t('ranking.restriction_reminder'),
          duration: 1500,
          className: 'ranking-toast',
        })
      },
      advanceCallAnimation(list = {}) {
        const { rankingDatas_top3 = [], rankingDatas = [] } = this
        const { kicoinId, liked } = list
        const handleFn = (dataSource) => {
          dataSource.forEach((item, index) => {
            if (item.kicoinId === kicoinId) {
              dataSource[index].liked = !liked
            }
          })
          return dataSource
        }
        if (rankingDatas_top3.some((item) => item.kicoinId === kicoinId)) {
          this.rankingDatas_top3 = handleFn([...rankingDatas_top3])
        } else {
          this.rankingDatas = handleFn([...rankingDatas])
        }
      },
    },
  }
</script>
<style lang="scss" src="./index.scss"></style>
<style scoped lang="scss">
  @media screen and (min-device-width: 1080px) {
    @import './index_pc.scss';
  }
</style>
<style>
  .ranking-home.public-page-wrapper.desktop-layout .van-popup.van-share-sheet {
    width: 600px;
    left: 50%;
    transform: translateX(-50%);
    height: 240px;
    overflow: hidden;
  }
  .ranking-home.public-page-wrapper.desktop-layout
    .van-popup.van-share-sheet
    .van-share-sheet__header {
    height: 60px;
  }
  .ranking-home.public-page-wrapper.desktop-layout
    .van-popup.van-share-sheet
    .van-share-sheet__options
    img {
    width: 60px;
    height: 60px;
  }
  .ranking-home.public-page-wrapper.desktop-layout
    .van-popup.van-share-sheet
    .van-share-sheet__options
    .van-share-sheet__name {
    font-size: 16px;
    line-height: 1;
  }
  .van-toast.van-toast--middle.van-toast--fail {
    width: 100px;
  }
</style>
